import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWalletTick = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Add Transaction Icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M13.3337 4L6.00033 11.3333L2.66699 8",
			stroke: "#3C3C3C",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgWalletTick;
